export default "__VITE_ASSET__qMfFhM1V__"